import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { resetStore } from './resetStore';
import { headers } from '../apiConfig';
import { getServerUrl } from '../../Utils/serverSelector';
import { saveJwtToken } from '../../Utils/authStorage';
import { getJwtToken } from '../../Utils/authStorage'; // добавить импорт

// ===============================
//   sessionStorage helpers (для восстановления аккаунта на iOS)
// ===============================

const SESSION_KEY = 'master_account';

const saveToSession = (account) => {
  try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(account)); } catch { }
};

const loadFromSession = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

const clearSession = () => {
  try { sessionStorage.removeItem(SESSION_KEY); } catch { }
};

// ===============================
//   Async Thunks
// ===============================

// Мастер работает только через httpOnly куку — токен в localStorage не сохраняем
export const loginMaster = createAsyncThunk(
  'master/loginMaster',
  async (phone, thunkAPI) => {
    try {
      const res = await axios.post(
        `${getServerUrl()}/auth/master-login`,
        { phone },
        { headers, withCredentials: true }
      );
      if (res.data.token) {
        saveJwtToken(res.data.token); // ← сохраняем JWT
      }
      return res.data.account;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Login error');
    }
  }
);

export const fetchMasterSession = createAsyncThunk(
  'master/fetchMasterSession',
  async (_, thunkAPI) => {
    const cached = loadFromSession();
    if (cached) return cached;

    const jwtToken = getJwtToken();
    if (!jwtToken) {
      return thunkAPI.rejectWithValue('No token');
    }

    try {
      const res = await axios.get(
        `${getServerUrl()}/auth/master-session`,
        {
          headers: { ...headers, Authorization: `Bearer ${jwtToken}` },
          withCredentials: true,
        }
      );
      saveToSession(res.data);
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || 'Session error');
    }
  }
);


export const logoutMaster = createAsyncThunk(
  'master/logoutMaster',
  async () => {
    clearSession(); // ← СНАЧАЛА чистим sessionStorage
    try {
      await axios.post(
        `${getServerUrl()}/auth/logout`,
        {},
        { headers, withCredentials: true }
      );
    } catch { } // ← игнорируем ошибку сети
    return true;
  }
);
// ===============================
//   Slice
// ===============================

const masterSessionSlice = createSlice({
  name: 'masterSession',
  initialState: {
    currentAccount: null,
    loading: false,
    error: null,
    isAuthenticated: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginMaster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginMaster.fulfilled, (state, action) => {
        state.currentAccount = action.payload;
        state.loading = false;
        state.isAuthenticated = true;
        saveToSession(action.payload);
      })
      .addCase(loginMaster.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      .addCase(fetchMasterSession.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMasterSession.fulfilled, (state, action) => {
        state.currentAccount = action.payload;
        state.isAuthenticated = true;
        state.loading = false;
        saveToSession(action.payload);
      })
      .addCase(fetchMasterSession.rejected, (state, action) => {
        state.error = action.payload;
        state.isAuthenticated = false;
        state.loading = false;
        clearSession();
      })

      .addCase(logoutMaster.fulfilled, (state) => {
        state.currentAccount = null;
        state.isAuthenticated = false;
        state.loading = false;
      })

      .addCase(resetStore, (state) => {
        state.currentAccount = null;
        state.isAuthenticated = false;
        state.loading = false;
        state.error = null;
        clearSession();
      });
  },
});

export default masterSessionSlice.reducer;